// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropoff-requested[data-v-2406b2aa]{position:relative;max-width:65%}@media(max-width:900px){.dropoff-requested[data-v-2406b2aa]{max-width:100%}}.dropoff-requested__actions[data-v-2406b2aa]{margin-top:30px;margin-bottom:90px}", ""]);
// Exports
module.exports = exports;
